import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/home.page";
import BlogListPage from "./pages/blog-list.page";
import WriteArticlePage from "./pages/write-article.page";
import BlogDetailPage from "./pages/blog-detail.page";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/blog-list" element={<BlogListPage />} />
          <Route path="/write-blog" element={<WriteArticlePage />} />
          <Route path="/detail-blog/:id" element={<BlogDetailPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
